export default __webpack_public_path__ + "static/media/logo-lg-768w.43b76cec.webp";